// Action Types
export const FETCH_NEXT_STEPS_MP_CARD_REQUEST = "FETCH_NEXT_STEPS_MP_CARD_REQUEST";
export const FETCH_NEXT_STEPS_MP_CARD_SUCCESS = "FETCH_NEXT_STEPS_MP_CARD_SUCCESS";
export const FETCH_NEXT_STEPS_MP_CARD_FAILURE = "FETCH_NEXT_STEPS_MP_CARD_FAILURE";


// Action Creators
export const fetchNextStepsMpCardRequest = ({opportunityId}) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_NEXT_STEPS_MP_CARD_REQUEST,
      payload: {opportunityId},
    });
  };
};
export const fetchNextStepsMpCardSuccess = (data) => ({
  type: FETCH_NEXT_STEPS_MP_CARD_SUCCESS,
  payload: data,
});
export const fetchNextStepsMpCardFailure = (error) => ({
  type: FETCH_NEXT_STEPS_MP_CARD_FAILURE,
  payload: error,
});
